export class TogglesStore {
    public toggles: {[key: string]: boolean} = {};
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/store/modules/toggles/index.ts